var map = {
	"./icons/TB-APP_Icon_Editing.svg": "./assets/img/icons/TB-APP_Icon_Editing.svg",
	"./icons/TB-APP_button_arrow_back-24px.svg": "./assets/img/icons/TB-APP_button_arrow_back-24px.svg",
	"./icons/TB-DB_icon_Logo.svg": "./assets/img/icons/TB-DB_icon_Logo.svg",
	"./icons/TB-DB_icon_Return.svg": "./assets/img/icons/TB-DB_icon_Return.svg",
	"./icons/TB-DB_icon_Shipping.svg": "./assets/img/icons/TB-DB_icon_Shipping.svg",
	"./icons/TB-DB_icon_Tessa_Expert.svg": "./assets/img/icons/TB-DB_icon_Tessa_Expert.svg",
	"./icons/TB-DB_icon_UUID.svg": "./assets/img/icons/TB-DB_icon_UUID.svg",
	"./icons/TB-DB_icon_heartbeat-dark.svg": "./assets/img/icons/TB-DB_icon_heartbeat-dark.svg",
	"./icons/TB-DB_icon_heartbeat.svg": "./assets/img/icons/TB-DB_icon_heartbeat.svg",
	"./icons/TB-DB_icon_inventory_black_24dp.svg": "./assets/img/icons/TB-DB_icon_inventory_black_24dp.svg",
	"./icons/TB-DB_icon_medical_information_black_24dp.svg": "./assets/img/icons/TB-DB_icon_medical_information_black_24dp.svg",
	"./icons/TB-DB_icon_medical_services_black_24dp.svg": "./assets/img/icons/TB-DB_icon_medical_services_black_24dp.svg",
	"./icons/TB_Android_Large_Checkmark_Icon.svg": "./assets/img/icons/TB_Android_Large_Checkmark_Icon.svg",
	"./icons/TB_Android_Large_Cross_Icon.svg": "./assets/img/icons/TB_Android_Large_Cross_Icon.svg",
	"./icons/TB_DB_Icon_SOURCE.svg": "./assets/img/icons/TB_DB_Icon_SOURCE.svg",
	"./icons/TB_Dashboard_Graph_hamburger-24px.svg": "./assets/img/icons/TB_Dashboard_Graph_hamburger-24px.svg",
	"./icons/TB_Dashboard_Icon_arrow_back-24px.svg": "./assets/img/icons/TB_Dashboard_Icon_arrow_back-24px.svg",
	"./icons/add-music.svg": "./assets/img/icons/add-music.svg",
	"./icons/amount.svg": "./assets/img/icons/amount.svg",
	"./icons/arrow_left.svg": "./assets/img/icons/arrow_left.svg",
	"./icons/arrow_right.svg": "./assets/img/icons/arrow_right.svg",
	"./icons/back-arrow.svg": "./assets/img/icons/back-arrow.svg",
	"./icons/balloon1.svg": "./assets/img/icons/balloon1.svg",
	"./icons/block.svg": "./assets/img/icons/block.svg",
	"./icons/calendar-recurring.svg": "./assets/img/icons/calendar-recurring.svg",
	"./icons/calendar.svg": "./assets/img/icons/calendar.svg",
	"./icons/category.svg": "./assets/img/icons/category.svg",
	"./icons/check-arrow-light.svg": "./assets/img/icons/check-arrow-light.svg",
	"./icons/check-small.svg": "./assets/img/icons/check-small.svg",
	"./icons/checkbox-checked-darkgreen.svg": "./assets/img/icons/checkbox-checked-darkgreen.svg",
	"./icons/checkbox-unchecked.svg": "./assets/img/icons/checkbox-unchecked.svg",
	"./icons/checkmark.svg": "./assets/img/icons/checkmark.svg",
	"./icons/clock.svg": "./assets/img/icons/clock.svg",
	"./icons/compare_arrows-24px.svg": "./assets/img/icons/compare_arrows-24px.svg",
	"./icons/content_copy_FILL0_wght400_GRAD0_opsz24.svg": "./assets/img/icons/content_copy_FILL0_wght400_GRAD0_opsz24.svg",
	"./icons/delete-forever.svg": "./assets/img/icons/delete-forever.svg",
	"./icons/dot.svg": "./assets/img/icons/dot.svg",
	"./icons/download.svg": "./assets/img/icons/download.svg",
	"./icons/dropdown.svg": "./assets/img/icons/dropdown.svg",
	"./icons/email.svg": "./assets/img/icons/email.svg",
	"./icons/error-small.svg": "./assets/img/icons/error-small.svg",
	"./icons/exit.svg": "./assets/img/icons/exit.svg",
	"./icons/fa-music.svg": "./assets/img/icons/fa-music.svg",
	"./icons/feedback.svg": "./assets/img/icons/feedback.svg",
	"./icons/help.svg": "./assets/img/icons/help.svg",
	"./icons/icon-envelop-blue.svg": "./assets/img/icons/icon-envelop-blue.svg",
	"./icons/icon-envelop.svg": "./assets/img/icons/icon-envelop.svg",
	"./icons/icon-mail.svg": "./assets/img/icons/icon-mail.svg",
	"./icons/icon_tessa.svg": "./assets/img/icons/icon_tessa.svg",
	"./icons/invoice.svg": "./assets/img/icons/invoice.svg",
	"./icons/language.svg": "./assets/img/icons/language.svg",
	"./icons/link.svg": "./assets/img/icons/link.svg",
	"./icons/magnify-creme.svg": "./assets/img/icons/magnify-creme.svg",
	"./icons/material-qr.svg": "./assets/img/icons/material-qr.svg",
	"./icons/new-dashboard.svg": "./assets/img/icons/new-dashboard.svg",
	"./icons/no-connection.svg": "./assets/img/icons/no-connection.svg",
	"./icons/overview.svg": "./assets/img/icons/overview.svg",
	"./icons/pairing.svg": "./assets/img/icons/pairing.svg",
	"./icons/password-strength-sterk.svg": "./assets/img/icons/password-strength-sterk.svg",
	"./icons/password-strength-zwak.svg": "./assets/img/icons/password-strength-zwak.svg",
	"./icons/password.svg": "./assets/img/icons/password.svg",
	"./icons/people_black_24dp.svg": "./assets/img/icons/people_black_24dp.svg",
	"./icons/person.svg": "./assets/img/icons/person.svg",
	"./icons/phone.svg": "./assets/img/icons/phone.svg",
	"./icons/playlist.svg": "./assets/img/icons/playlist.svg",
	"./icons/plus-icon.svg": "./assets/img/icons/plus-icon.svg",
	"./icons/plus.svg": "./assets/img/icons/plus.svg",
	"./icons/popup-pointer-green.svg": "./assets/img/icons/popup-pointer-green.svg",
	"./icons/popup-pointer-orange.svg": "./assets/img/icons/popup-pointer-orange.svg",
	"./icons/question-small.svg": "./assets/img/icons/question-small.svg",
	"./icons/relation.svg": "./assets/img/icons/relation.svg",
	"./icons/reorder-disabled.svg": "./assets/img/icons/reorder-disabled.svg",
	"./icons/reorder.svg": "./assets/img/icons/reorder.svg",
	"./icons/robot-and-voice-assistant.svg": "./assets/img/icons/robot-and-voice-assistant.svg",
	"./icons/router_white_24dp.svg": "./assets/img/icons/router_white_24dp.svg",
	"./icons/search.svg": "./assets/img/icons/search.svg",
	"./icons/subref.svg": "./assets/img/icons/subref.svg",
	"./icons/task-music-hover.svg": "./assets/img/icons/task-music-hover.svg",
	"./icons/task-music.svg": "./assets/img/icons/task-music.svg",
	"./icons/task-question-hover.svg": "./assets/img/icons/task-question-hover.svg",
	"./icons/task-question.svg": "./assets/img/icons/task-question.svg",
	"./icons/task-reminder-hover.svg": "./assets/img/icons/task-reminder-hover.svg",
	"./icons/task-reminder.svg": "./assets/img/icons/task-reminder.svg",
	"./icons/tb-db-icon-add-return-center.svg": "./assets/img/icons/tb-db-icon-add-return-center.svg",
	"./icons/tb-db-icon-add-return.svg": "./assets/img/icons/tb-db-icon-add-return.svg",
	"./icons/tb-db-icon-order-light.svg": "./assets/img/icons/tb-db-icon-order-light.svg",
	"./icons/tb-db-icon-order.svg": "./assets/img/icons/tb-db-icon-order.svg",
	"./icons/tb-db-icon-pay-ref.svg": "./assets/img/icons/tb-db-icon-pay-ref.svg",
	"./icons/tb-db-icon-retrieve-latest.svg": "./assets/img/icons/tb-db-icon-retrieve-latest.svg",
	"./icons/tb-db-icon-subscription-amount.svg": "./assets/img/icons/tb-db-icon-subscription-amount.svg",
	"./icons/tb_zendesk.png": "./assets/img/icons/tb_zendesk.png",
	"./icons/tessa-dark.svg": "./assets/img/icons/tessa-dark.svg",
	"./icons/tessa-grey.svg": "./assets/img/icons/tessa-grey.svg",
	"./icons/tessa-online-copy.svg": "./assets/img/icons/tessa-online-copy.svg",
	"./icons/tessa-online.svg": "./assets/img/icons/tessa-online.svg",
	"./icons/tinylogo.svg": "./assets/img/icons/tinylogo.svg",
	"./icons/tinylogo_2.svg": "./assets/img/icons/tinylogo_2.svg",
	"./icons/unknown.svg": "./assets/img/icons/unknown.svg",
	"./icons/uploading.svg": "./assets/img/icons/uploading.svg",
	"./icons/voice-assistant-blocked.svg": "./assets/img/icons/voice-assistant-blocked.svg",
	"./icons/voice-assistant.svg": "./assets/img/icons/voice-assistant.svg",
	"./icons/warning.svg": "./assets/img/icons/warning.svg",
	"./logos/tessa-error-large.svg": "./assets/img/logos/tessa-error-large.svg",
	"./logos/tinybots-icon.svg": "./assets/img/logos/tinybots-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/img sync recursive ^\\.\\/.*$";